module.exports = __webpack_public_path__ + "img/7z.1383f2ef.svg";